import React, { useEffect } from 'react';
import { DaOffer, Platform } from '../../types';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import cn from 'classnames';
import Vlitejs from 'vlitejs';

import './vlite.global.css';
import s from './Video.scss';

export interface Props {
  banner: NonNullable<DaOffer['asset']['creative']['videobanner']>;
  platform: Platform;
  onCtaClick: (url?: string) => void;
}

const Video: React.FC<Props> = ({
  banner: bannerOffer,
  platform,
  onCtaClick,
}) => {
  // Mobile is optional but usually comes as empty object so fallback to desktop when not present
  let banner: Partial<typeof bannerOffer.desktop> = bannerOffer.desktop;
  if (
    platform === 'mobile' &&
    bannerOffer.mobile &&
    Object.keys(bannerOffer.mobile).length > 0 &&
    bannerOffer.mobile.videoURL
  ) {
    banner = bannerOffer.mobile!;
  }

  useEffect(() => {
    new Vlitejs('#player', {
      options: {
        controls: true,
        autoplay: true,
        playPause: true,
        progressBar: true,
        time: false,
        volume: true,
        fullscreen: true,
        poster: banner.videoPoster,
        bigPlay: false,
        playsinline: true,
        loop: true,
        muted: false,
        autoHide: true,
      },
      onReady: () => {
        const overlay = document.querySelector('.v-overlay');
        if (overlay) {
          overlay.addEventListener('click', () => {
            onCtaClick(banner.ctaURL);
            window.open(banner.ctaURL, '_blank');
          });
        }
      },
    });
  }, [banner.ctaURL, banner.videoPoster, onCtaClick]);

  if (!bannerOffer || !banner) {
    return null;
  }

  return (
    <div className={cn(s['root'])}>
      <video crossOrigin="anonymous" id="player" src={banner.videoURL}></video>
      {banner.ctaText && (
        <SolidButton
          className={s['cta']}
          size="medium"
          variant="main"
          href={banner.ctaURL}
          target="_blank"
          onClick={() => onCtaClick(banner.ctaURL)}
        >
          {banner.ctaText}
        </SolidButton>
      )}
    </div>
  );
};

export default Video;
